<template>
  <div>
    <GridColumnMenuSort v-if="sortable"
        :column="column"
        :sortable="sortable"
        :sort="sort"
        @closemenu="closeMenu"
        @sortchange="sortChange"/>
    <GridColumnMenuItemGroup v-if="hasColumns">
      <GridColumnMenuItem
        :title="$t('app.hide_show_columns')"
        icon-class="k-i-columns"
        @menuitemclick="onMenuItemClick"
      />
      <GridColumnMenuItemContent :show="columnsExpanded">
        <div class="k-column-list-wrapper">
          <form @submit="onSubmit" @reset="onReset">
            <div class="k-column-list">
              <div :key="idx" class="k-column-list-item" v-for="(column, idx) in currentColumns">
                <span>
                  <input
                    :id="'column-visiblity-show-' + idx"
                    class="k-checkbox"
                    type="checkbox"
                    :readOnly="true"
                    :disabled="!column.hidden && oneVisibleColumn"
                    :checked="!column.hidden"
                    @click="onToggleColumn(idx)"
                  />
                  <label
                    :for="'column-visiblity-show-' + idx"
                    class="k-checkbox-label"
                    :style="{ userSelect: 'none' }"
                  >
                    {{column.title}}
                  </label>
                </span>
              </div>
            </div>
            <div class="k-columnmenu-actions">
              <button type="reset" class="k-button">{{ $t('app.show_all') }}</button>
              <button class="k-button k-primary">{{ $t('app.save') }}</button>
            </div>
          </form>
        </div>
      </GridColumnMenuItemContent>
    </GridColumnMenuItemGroup>
    <GridColumnMenuItem
      :title="$t('app.block_unblock_column')"
      icon-class="k-i-columns"
      @menuitemclick="lockUnlockColum(column)"
    />
  </div>
</template>
<script>
import {
  GridColumnMenuSort,
  GridColumnMenuItemGroup,
  GridColumnMenuItemContent,
  GridColumnMenuItem
} from '@progress/kendo-vue-grid'

export default {
  components: {
    GridColumnMenuSort,
    GridColumnMenuItemGroup,
    GridColumnMenuItemContent,
    GridColumnMenuItem
  },
  props: {
    column: Object,
    sortable: [Boolean, Object],
    sort: {
      type: Array
    },
    filter: Object,
    filterable: Boolean,
    columns: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentColumns: [],
      columnsExpanded: false,
      filterExpanded: false
    }
  },
  computed: {
    oneVisibleColumn: function () {
      return this.currentColumns.filter(c => !c.hidden).length === 1
    },
    numLocked: function () {
      return this.currentColumns.filter(x => x.locked).length
    },
    hasColumns: function () {
      return !!this.currentColumns.length
    },
  },
  created: function () {
    this.currentColumns = this.columns
  },
  methods: {
    onToggleColumn (id) {
      this.currentColumns = this.currentColumns.map((column, idx) => {
        return idx === id ? { ...column, hidden: !column.hidden } : column
      })
    },
    onReset (event) {
      event.preventDefault()
      const allColumns = this.$props.columns.map(col => {
        return {
          ...col,
          hidden: false
        }
      })

      this.currentColumns = allColumns
      this.onSubmit()
    },
    onSubmit (event) {
      if (event) {
        event.preventDefault()
      }
      this.$emit('columnssubmit', this.currentColumns)
      this.$emit('closemenu')
    },
    onMenuItemClick () {
      const value = !this.columnsExpanded
      this.columnsExpanded = value
      this.filterExpanded = value ? false : this.filterExpanded
    },
    onFilterExpandChange (value) {
      this.filterExpanded = value
      this.columnsExpanded = value ? false : this.columnsExpanded
    },
    expandChange () {
      this.$emit('expandchange')
    },
    closeMenu () {
      this.$emit('closemenu')
    },
    filterChange (newDescriptor, e) {
      this.$emit('filterchange', newDescriptor, e)
    },
    sortChange (newDescriptor, e) {
      this.$emit('sortchange', newDescriptor, e)
    },
    lockUnlockColum: function (currentColumn) {
      this.currentColumns = this.currentColumns.map((column) => {
        return column.field === currentColumn.field ? { ...column, locked: !column.locked, reorderable: column.locked } : column
      })
      // this.currentColumns = this.currentColumns.sort(compare)
      // Fix TMP Bug Lock => Reorder => Unlock
      this.currentColumns = this.currentColumns.map((column) => {
        if (this.numLocked > 0) column.reorderable = false
        else column.reorderable = true
        return column
      })
      this.$emit('columnssubmit', this.currentColumns)
      this.$emit('closemenu')
    }
  }

}
// function compare (a, b) {
//   if (a.locked > b.locked) {
//     return -1
//   }
//   if (a.locked < b.locked) {
//     return 1
//   }
//   return 0
// }
</script>
